/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { NavRoute } from "@src/app/shared/NavRoute";
import { ActionPageComponent } from "@src/app/modules/crm/action-page/action-page.component";

export const ActionPageNavRoute = new NavRoute('crm/actions', ()=>ActionPageComponent, 'assignment_turned_in').setCharts([
    { type: 'pie', picklist: 'omcManagerId' } as ChartParms,
    { type: 'bar', picklist: 'omcId', trend: 'weekCompleted'} as ChartParms,
    { type: 'bar', picklist: 'templateId' } as ChartParms,
    { type: 'pie', picklist: 'done', metric: 'timeSpent'} as ChartParms
]).setViews((u: User) => { return [
    {
        id: 'myopen',
        name: 'My Open Actions',
        helpText: 'Open actions assigned to you; change the filter to view another team member\'s actions',
        filterFields: {
            ownedById: u.id, done: 0, omcId: 'All'
        },
        sort: 'plannedDate',
        charts: [
            { type: 'bar', picklist: 'templateId'} as ChartParms,
            { type: 'pie', picklist: 'omcManagerId', trend: 'weekCompleted'} as ChartParms,
            { type: 'bar', picklist: 'omcId' } as ChartParms,
        ]
    },
    {
        id: 'myomcopen',
        name: 'My OMCs Open Actions',
        helpText: 'Open actions across OMCs you manage; change the filter to view another manager\'s OMCs',
        filterFields: {omcManagerId: u.id, done: 0},
        sort: 'plannedDate',
        charts: [
            { type: 'pie', picklist: 'ownedById'} as ChartParms,
            { type: 'bar', picklist: 'omcId', trend: 'weekCompleted'} as ChartParms,
            { type: 'bar', picklist: 'templateId'} as ChartParms,
            { type: 'pie', picklist: 'planned', metric: 'timeSpent'} as ChartParms
        ]
    },
    {
        id: 'myomc_unplanned',
        name: 'My OMCs Unplanned',
        helpText: 'Unplanned actions across OMCs you manage; change the filter to view another manager\'s OMCs',
        filterFields: {omcManagerId: u.id, planned: 0},
        sort: 'id',
        charts : [
            { type: 'bar', picklist: 'omcId', trend: 'weekCompleted' } as ChartParms,
            { type: 'bar', picklist: 'templateId' } as ChartParms,
            { type: 'pie', picklist: 'done', metric: 'timeSpent'} as ChartParms
        ]
    },
    {
        id: 'all_open_actions',
        name: 'All Open Items',
        helpText: 'All open actions across all OMCs',
        filterFields: { done: 0 },
        sort: 'id',
        charts: [
            { type: 'pie', picklist: 'omcManagerId' } as ChartParms,
            { type: 'bar', picklist: 'omcId' } as ChartParms,
            { type: 'pie', picklist: 'ownedById' } as ChartParms
        ]
    },
    {
        id: 'all_unplanned',
        name: 'All Unplanned',
        helpText: 'All actions with no planned date',
        filterFields: {planned: 0},
        sort: 'id',
        charts: [
            { type: 'pie', picklist: 'omcManagerId'} as ChartParms,
            { type: 'bar', picklist: 'omcId', trend: 'weekCompleted' } as ChartParms,
            { type: 'bar', picklist: 'templateId' } as ChartParms,
            { type: 'pie', picklist: 'done', metric: 'timeSpent' } as ChartParms
        ]
    },
    {
        id: 'all',
        name: 'All Actions',
        helpText: 'All actions, open and completed',
        charts: [
            { type: 'pie', picklist: 'omcManagerId' } as ChartParms,
            { type: 'bar', picklist: 'omcId', trend: 'weekCompleted' } as ChartParms,
            { type: 'trend', picklist: 'ownedById', trend: 'weekCompleted' } as ChartParms,
            { type: 'pie', picklist: 'done', metric: 'timeSpent' } as ChartParms
        ]
    }
]});
